<template>
  <div>
    <div id="layout-wrapper">
      <NavBar/>
      <SideBar
      :isCondensed="isMenuCondensed"
      :type="leftSidebarType"
      :width="layoutWidth"
    />

      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">

            <slot></slot>

          </div>
        </div>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/menu/side-bar";
import NavBar from "@/components/menu/nav-bar";
import Footer from "@/components/footer";

export default {
  components: { SideBar, NavBar, Footer, },
  data() {
    return {
      isMenuCondensed: true,
      leftSidebarType: "light",
      layoutWidth: "scrollable",
      path: ""
    };
  },
  created(){

  },

};

</script>
